import MListItem from "@mui/material/ListItem";
import MListItemText from "@mui/material/ListItemText";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

const ListItem = styled(MListItem, { name: "AppListItem" })(({ disablePadding }) => ({
  padding: disablePadding ? "0px !important" : undefined,
}));

const ListItemText = styled(MListItemText, {
  name: "AppListItemText",
  shouldForwardProp(propName) {
    return propName !== "disableMargin";
  },
})<{
  disableMargin?: boolean;
}>(({ disableMargin }) => ({
  margin: disableMargin ? "0px !important" : undefined,
}));

export const TitleWithCounterContainer = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  gap: "4px",
}));

export const Badge = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  backgroundColor: colors.gray500,
  height: "16px",
  marginLeft: "4px",
  minWidth: "16px",
  width: "fit-content",
  color: colors.white,
  fontWeight: 600,
  lineHeight: "16px",
  fontSize: "11px",
  textAlign: "center",
  fontFamily: "Manrope",
  fontStyle: "normal",
  letterSpacing: "0.5px",
  padding: "0 4px",
  borderRadius: "100px",
}));

export { ListItem, ListItemText };
